// extracted by mini-css-extract-plugin
export var WazeButton = "index-module--WazeButton--78d8e";